/** Один запрос subject-data на субъект (дедупликация при Strict Mode и повторных вызовах). */

import { API_BASE } from '../../../config';

const inflight = new Map();

function requestKey(subjectId, subjectName) {
  if (subjectId != null && subjectId !== '') {
    return `id:${subjectId}`;
  }
  const name = (subjectName || '').trim();
  return name ? `name:${name}` : '';
}

/**
 * @returns {Promise<{ ok: boolean, data: { branches?: string[], forest_locations?: string[] } | null }>}
 */
export async function fetchSubjectDataOnce(subjectId, subjectName) {
  const key = requestKey(subjectId, subjectName);
  if (!key) {
    return { ok: false, data: null };
  }
  if (inflight.has(key)) {
    return inflight.get(key);
  }

  const promise = (async () => {
    const params = new URLSearchParams();
    if (subjectId != null && subjectId !== '') {
      params.set('subject_id', String(subjectId));
    }
    if (subjectName) {
      params.set('name', subjectName);
    }
    try {
      const response = await fetch(`${API_BASE}/subject-data/?${params.toString()}`);
      if (!response.ok) {
        return { ok: false, data: null };
      }
      const data = await response.json();
      return { ok: true, data };
    } catch {
      return { ok: false, data: null };
    }
  })();

  inflight.set(key, promise);
  try {
    return await promise;
  } finally {
    inflight.delete(key);
  }
}
